var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M459.4 151.7c20.8-14.8 38.3-33.2 52.6-54.5-19.1 8.3-39.3 13.9-60.5 16.6 21.8-13 38.4-33.4 46.2-58-20.3 12.1-42.7 20.6-66.6 25.4C411.9 60.7 384.4 48 354.5 48c-58.1 0-104.9 47.2-104.9 105 0 8.3.7 16.3 2.4 23.9-87.3-4.3-164.5-46.1-216.4-109.8-9 15.7-14.4 33.7-14.4 53.1 0 36.4 18.7 68.6 46.6 87.2-16.9-.3-33.4-5.2-47.4-12.9v1.2c0 51 36.4 93.4 84.1 103.1-8.6 2.3-17.9 3.5-27.5 3.5-6.7 0-13.5-.4-19.9-1.8 13.6 41.6 52.2 72.1 98.1 73.1-35.7 27.9-81.1 44.8-130.2 44.8-8.6 0-16.9-.4-25.1-1.4 46.5 30 101.6 47.1 161 47.1C346.3 464 467 309.5 459.4 151.7z",
    style: {
      fill: "#d1d1d1"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f71682c8ae95629b14ad07eb13e311ee.svg";
export { ForwardRef as ReactComponent };